import { createThemeStore } from '@dak/ui';

export const useThemeStore = createThemeStore({ storageKey: 'notes-theme' });
